import { useState } from 'react';
import { PlusCircle, KeyRound, Mountain, Zap } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { JoinByCodeModal } from '@/components/home/JoinByCodeModal';

export function QuickActions() {
    const { t } = useTranslation('home');
    const [showJoinModal, setShowJoinModal] = useState(false);

    return (
        <>
            <div className="space-y-4">
                <h2 className="text-lg font-bold text-slate-900 flex items-center gap-2">
                    <Zap size={20} className="text-emerald-500" />
                    {t('sections.quickActions')}
                </h2>

                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-2 gap-3">
                    <Link
                        to="/races/create"
                        className="bg-white p-4 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md hover:border-emerald-100 transition-all group flex flex-col items-center text-center gap-2"
                    >
                        <div className="w-10 h-10 bg-emerald-50 rounded-full flex items-center justify-center text-emerald-500 group-hover:bg-emerald-100 transition-colors">
                            <PlusCircle size={20} />
                        </div>
                        <span className="text-sm font-bold text-slate-700 group-hover:text-emerald-700 transition-colors">
                            {t('quickActions.createRace')}
                        </span>
                    </Link>

                    <button
                        onClick={() => setShowJoinModal(true)}
                        className="bg-white p-4 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md hover:border-emerald-100 transition-all group flex flex-col items-center text-center gap-2"
                    >
                        <div className="w-10 h-10 bg-violet-50 rounded-full flex items-center justify-center text-violet-500 group-hover:bg-violet-100 transition-colors">
                            <KeyRound size={20} />
                        </div>
                        <span className="text-sm font-bold text-slate-700 group-hover:text-violet-700 transition-colors">
                            {t('quickActions.joinPrivate')}
                        </span>
                    </button>

                    <Link
                        to="/races"
                        className="bg-white p-4 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md hover:border-emerald-100 transition-all group flex flex-col items-center text-center gap-2 col-span-2 md:col-span-1 lg:col-span-2"
                    >
                        <div className="w-10 h-10 bg-sky-50 rounded-full flex items-center justify-center text-sky-500 group-hover:bg-sky-100 transition-colors">
                            <Mountain size={20} />
                        </div>
                        <span className="text-sm font-bold text-slate-700 group-hover:text-sky-700 transition-colors">
                            {t('quickActions.browseRaces')}
                        </span>
                    </Link>
                </div>
            </div>

            {showJoinModal && <JoinByCodeModal onClose={() => setShowJoinModal(false)} />}
        </>
    );
}
